import React, { useEffect, useState } from 'react';

/**
 * Checks the frontend build metadata from the current site origin.
 * This deliberately does not use the backend API helper, because the backend
 * may be on a different host/build and should not control the loaded UI bundle.
 */
const LOADED_BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || '';

function VersionChecker() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(null);

  useEffect(() => {
    async function checkVersion() {
      if (!LOADED_BUILD_NUMBER) return;

      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache' },
        });
        if (!response.ok) return;
        const data = await response.json();

        setCurrentVersion(data.version);
        if (data.buildNumber && data.buildNumber !== LOADED_BUILD_NUMBER) {
          console.log(`Update available: build ${LOADED_BUILD_NUMBER} -> ${data.buildNumber}`);
          setUpdateAvailable(true);
        }
      } catch (error) {
        console.error('Version check failed:', error);
      }
    }

    checkVersion();
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    const handleVisibilityChange = () => {
      if (!document.hidden) checkVersion();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-blue-600 text-white py-2 px-4 shadow-lg z-50 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold">Refresh</span>
        <span className="font-medium">
          New version available ({currentVersion}) - click to update
        </span>
      </div>
      <button
        onClick={() => window.location.reload()}
        className="bg-white text-blue-600 px-4 py-1 rounded font-medium hover:bg-blue-50 transition"
      >
        Update Now
      </button>
    </div>
  );
}

export default VersionChecker;
